module.exports = __webpack_public_path__ + "static/media/corporate-cta.caae93fc.jpg";